<template>
  <div class="filter">
    <!-- <div class="list">
      <div v-for="(item, i) in types" :key="i">
          <router-link
            :to="`/dashboard/fertilizers/${item}/${page}/${id}`"
            class="default"
            :active="item === type ? true : false"
          >
            {{item.toUpperCase()}}
          </router-link>
      </div>
    </div> -->
    <SidebarSwitcher
      @input="selectType"
      :items="types"
      :value="type"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SidebarSwitcher from '@/components/common/SidebarSwitcher'

export default {
  data: function () {
    return {
      types: [
        {
          key: 'all',
          label: this.$ml.get(`all`),
        },
        {
          key: 'solid',
          label: this.$ml.get(`Solid`),
        },
        {
          key: 'liquid',
          label: this.$ml.get(`Liquid`),
        },
        {
          key: 'acid',
          label: this.$ml.get(`Acid`),
        },
      ]
    }
  },
  computed: {
    ...mapGetters({
      type: 'fertilizers/getType',
      id: 'fertilizers/getId',
      // page: 'fertilizers/getPage'
    }),
  },
  created() {
    // console.log(this.$ml.get(`all`));
  },
  components: {
    SidebarSwitcher
  },
  methods: {
    selectType(type) {
      this.$store.commit('fertilizers/savePage', 0);
      this.$router.push(`/dashboard/fertilizers/${type}/${this.id}`);

      this.$emit('dropPage');
    }
  }
}
</script>

<style lang="scss" scoped>
.filter {
  width: 100%;
  // padding: 10px 20px;
  padding-bottom: 0;

  .list {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 5px 5px;
    // background: #DDDDDD;

    div {
      font-size: 12px;
      // color: #8B8D91;
      font-weight: bold;
      cursor: pointer;

      &:hover {
        color: $mainGreen;
      }
    }

    .router-link-active {
      color: $mainGreen !important;
    }
    .default {
      color: #8B8D91;
    }
  }
}
</style>
